import React from 'react'
import { Text } from 'theme-ui'

import { NumberItemStyled, NumberItemValueStyled, NumberItemTitleStyled, NumberItemCaptionStyled } from './styles'
import { NumberItemProps } from './types'

const NumberItem: React.FC<NumberItemProps> = ({ number, currency, title, caption, isAlt, isHorizontal, numberAltFont }) => {
  return (
    <NumberItemStyled {...{ isAlt, isHorizontal }}>
      <NumberItemValueStyled>
        <Text
          sx={{
            variant: `${numberAltFont ? 'bodyMontserrat28' : 'headingRaleway5'}`,
            fontFamily: `${numberAltFont ? 'primary' : 'secondary'}`
          }}
        >
          {number}
          {currency && currency}
        </Text>
      </NumberItemValueStyled>
      {title && (
        <NumberItemTitleStyled>
          <Text
            sx={{
              variant: 'bodyMontserrat27'
            }}
          >
            {title}
          </Text>
        </NumberItemTitleStyled>
      )}
      {caption && (
        <NumberItemCaptionStyled>
          <Text
            sx={{
              variant: isAlt ? 'bodyRaleway8' : 'headingRaleway3',
              fontFamily: 'secondary'
            }}
          >
            {caption}
          </Text>
        </NumberItemCaptionStyled>
      )}
    </NumberItemStyled>
  )
}

export default NumberItem
